var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Prop } from 'vue-property-decorator';
import { removeHttp } from '../../../common/utils';
import { Component, VueType } from '../core';
import CornerMark from '../common/corner-mark/CornerMark';
import { useNewCornerMark } from '../../../common/format';
import { toDtPosterParams, toDtButtonParams, DtModuleId, DtEid } from '../../../common/reporter';
let BingeItem = class BingeItem extends VueType {
    get url() {
        var _a, _b, _c;
        const { data } = this;
        const item = data;
        if ((_a = item.itemParams) === null || _a === void 0 ? void 0 : _a.cid) {
            return `//v.qq.com/x/cover/${item.itemParams.cid}.html`;
        }
        if ((_b = item.itemParams) === null || _b === void 0 ? void 0 : _b.lid) {
            return `//v.qq.com/x/cover/${item.itemParams.lastCover}.html`;
        }
        if ((_c = item.itemParams) === null || _c === void 0 ? void 0 : _c.pid) {
            return `//v.qq.com/live/p/newtopic/${item.itemParams.pid}/index.html`;
        }
        const noHref = 'javascript:;';
        return noHref;
    }
    get pic() {
        var _a, _b;
        const { data } = this;
        const pic = (_b = (_a = data) === null || _a === void 0 ? void 0 : _a.itemParams) === null || _b === void 0 ? void 0 : _b.newPicHz;
        return removeHttp(pic);
    }
    get title() {
        var _a, _b;
        const { data } = this;
        return (_b = (_a = data) === null || _a === void 0 ? void 0 : _a.itemParams) === null || _b === void 0 ? void 0 : _b.title;
    }
    get attentKey() {
        var _a, _b;
        const { data } = this;
        return (_b = (_a = data) === null || _a === void 0 ? void 0 : _a.itemParams) === null || _b === void 0 ? void 0 : _b.attentKey;
    }
    get dtPosterParams() {
        return toDtPosterParams({
            mod_id: DtModuleId.FOLLOWING,
            mod_idx: 1,
            item_idx: this.itemIdx,
            vid: this.data.itemParams.vid,
            cid: this.data.itemParams.cid,
            lid: this.data.itemParams.lid,
            is_hover: 0,
        });
    }
    get dtButtonParams() {
        return toDtButtonParams({
            title: 'delete_poster',
        });
    }
    get cornerMarkSrc() {
        var _a, _b;
        return useNewCornerMark((_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.itemParams) === null || _b === void 0 ? void 0 : _b.uniImgtagOrig);
    }
    render() {
        return <div class="binge_item item_size " v-wind dt-eid={DtEid.POSTER} dt-params={this.dtPosterParams}>
              <a class="binge_item_pic del_par" href={this.url} target="_blank" dt-source-el={this.dtPosterParams}>
                <div class="pic_container">
                  <img class="pic_bg" v-src={this.pic}/>
                  <img class="pic_raw" v-src={this.pic}/>
                  <CornerMark position='rightTop' size='medium' data={this.cornerMarkSrc}></CornerMark>
                </div>
                <div class="hover_mask">
                    <div class="hover_mask_play"></div>
                    <svg class="del_x" data-del={this.attentKey} dt-eid={DtEid.BUTTON} dt-params={this.dtButtonParams} dt-source-ignore>
                      <use xlinkHref="#svg_clear_item"></use>
                    </svg>
                </div>
            </a>
            <strong class="binge_item_title_box">
                <a class="nowrap_two" title={this.title} href={this.url} target="_blank" dt-source-el={this.dtPosterParams}>{this.title}</a>
            </strong>
        </div>;
    }
};
__decorate([
    Prop()
], BingeItem.prototype, "data", void 0);
BingeItem = __decorate([
    Component
], BingeItem);
export default BingeItem;
